import { styled } from 'styled-components';

import { colors, cssBreakpoints, fontSizes, spacing } from '#/theme/theme';

export const FieldErrorContainer = styled.div<{
  $inlineLabel?: boolean;
  $noWrap?: boolean;
  $noMargin?: boolean;
}>`
  display: flex;
  align-items: center;
  width: fit-content;
  margin-top: ${spacing[16]};
  padding: ${spacing[6]} ${spacing[12]};
  line-height: normal;
  font-size: ${fontSizes[14]};
  color: ${colors.alertRed};
  background-color: ${colors.lightRed};
  border-radius: 8px;
  ${(props) =>
    props.$inlineLabel &&
    `
    position: absolute;
    top: 50%;
    right: 18px;
    transform: translateY(-50%);
    margin-top: 0;
  `}
  ${(props) =>
    props.$noWrap
      ? `
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    white-space: nowrap;
  }`
      : ''}
  ${(props) =>
    props.$noMargin &&
    `
   margin: 0; 
  `}
`;
